import { Flex, Text } from "@chakra-ui/react"
import Wrapper from "components/layout/wrapper"
import AdBlock from "components/ads/adBlock"

const defaultAdSizes = [
    [
        // desktop
        [900, 300],
        [970, 90],
        [728, 210],
        [728, 90],
        // mobile
        [350, 44],
        [320, 100],
        [320, 50],
        [240, 400],
    ],
]

export default function Ad({ block, ...rest }) {
    // format sizes as an array of arrays, as Google likes 'em
    const sizesArray = block.sizes
        ? block.sizes.map(size => {
              return [size.width, size.height]
          })
        : defaultAdSizes

    return (
        <Wrapper bg="#fff" mt={4} pt="15px" pb="15px" {...rest}>
            <Flex justify="center" align="center" direction="column">
                <Text color="#333" fontSize="11px!important" mt={1} mb={1}>
                    Advertisement
                </Text>
                <AdBlock adUnit={block.ad || block.adUnit} sizes={sizesArray} />
            </Flex>
        </Wrapper>
    )
}
